module.exports = __webpack_public_path__ + "img/about-header.jpg?fdf1130b137e6a2bfa9c9c3419980f11";